import { ForbiddenError } from '@ember-data/adapter/error';

// Narrow ForbiddenError swallow — for *optional* fetches only. Returns
// `fallback` on 403 so a custom role with limited permissions doesn't trip
// the global handler at application/route.ts (which redirects to /forbidden).
// Don't wrap primary-resource fetches: a real 403 there should preserve the
// security boundary.
export default function swallowForbidden<T, F>(promise: Promise<T>, fallback: F): Promise<T | F> {
  return promise.catch((e: unknown) => {
    if (e instanceof ForbiddenError) return fallback;
    throw e;
  });
}
